// Main component export
import GmailInboxComponent from './Components/GmailInbox';
export { GmailInboxComponent as GmailInbox };
export { default as ComposeBox } from './Components/ComposeBox';
export default GmailInboxComponent;

// Type exports
export type { EmailData, EmailOption } from './Components/GmailInbox';
export { useTheme, type Theme } from './context/ThemeContext';
export type { ComposeBoxProps, AiInsertHandler, AiDiscardHandler } from './Components/ComposeBox/types';

// Re-export types for convenience
export type { Alignment } from './Components/core/AlignmentSelect';
